import { ReclamationForm } from '../components/reclamaciones/ReclamationForm';
import { COMPLAINTS_CONFIG } from '../data/reclamaciones';
import { useDocumentMeta } from '../hooks/useDocumentMeta';

export function ComplaintsBookPage() {
  useDocumentMeta({
    title: 'Libro de Reclamaciones | Corporación Indemniza',
    description: 'Registra un reclamo o queja dirigido a Corporación Indemniza.',
    canonicalPath: '/libro-de-reclamaciones',
  });

  return (
    <div className="complaints-page">
      <header className="complaints-hero">
        <div className="site-container complaints-hero__inner">
          <p className="eyebrow">Atención al consumidor</p>
          <h1>Libro de Reclamaciones</h1>
          <p>
            Registra aquí un reclamo relacionado con un producto o servicio, o una queja respecto de la atención recibida.
            La respuesta será remitida por el medio seleccionado dentro del plazo máximo de {COMPLAINTS_CONFIG.responseBusinessDays} días hábiles.
          </p>
        </div>
      </header>
      <main className="site-container complaints-main">
        <ReclamationForm />
      </main>
    </div>
  );
}
